import { roundNames } from '../data'

import useAuth from '../../../../auth/useAuth';

import './styles.css';

export default function Header({ 
  roundCount,
  currentRound,
  gameType,
  isNextRoundButtonDisabled,
  isReviewButtonLoading,
  onReviewButtonClick,
  isReviewButtonDisabled
}) {
  const { isInstructor } = useAuth();

  const offset = roundNames.length - roundCount;
  const availableRounds = roundNames.slice(offset, roundNames.length);

  const isLastRound = currentRound === roundCount;
  const visibleRounds = isLastRound
    ? availableRounds.slice(0, currentRound - 1)
    : availableRounds.slice(0, currentRound);

  return (
    <div className={`tournament-bracket-header round-count-${roundCount}`}>
      <div className="tournament-bracket-header-inner">
        <div className="tournament-round-names">
          {visibleRounds.map((round, index) => (
            <div className={`tournament-round-container ${round.toLowerCase().replace(/\s/g, '-')}`} key={index}>
              <span
                className={`tournament-round ${!isLastRound && index === visibleRounds.length - 1 ? 'active' : ''}`}
              >
                {round}
              </span>
            </div>
          ))}
        </div>

        <div className="tournament-game-type" data-tour-id="competition-overview-anchor">
          <span>{gameType}</span>
          {
            isInstructor() && 
              <button 
                className={`review-tournament-game-button ${isReviewButtonLoading ? 'loading' : ''}`}
                onClick={onReviewButtonClick}
                disabled={isReviewButtonDisabled}
              >
                {!isReviewButtonLoading && 'Review'}
              </button>
          }
        </div>

        <div className="tournament-round-names">
          {visibleRounds
            .slice()
            .reverse()
            .map((round, index) => (
              <div className={`tournament-round-container ${round.toLowerCase().replace(/\s/g, '-')}`} key={index}>
                <span
                  className={`tournament-round ${!isLastRound && index === 0 ? 'active' : ''}`}
                >
                  {round}
                </span>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}
